import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetSalesCountResponse {
    pending_customer_count: number;
    total_pending_amount: number;
    monthly_sales_amount: number;
    monthly_order_count: number;
    monthly_payment_amount: number;
}

export const useGetSalesCount = (): UseQueryResult<GetSalesCountResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetSalesCountResponse, Error>({
        queryKey: ["getSalesCount"],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_sales_count}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
